// https://github.com/biati-digital/glightbox

const customLightboxHTML = (variation = "") => {
  return `<div id="glightbox-body" class="glightbox-container avvio-lightbox avvio-${variation}">
  <div class="gloader visible avvio-lightbox__loader"></div>
  <div class="goverlay avvio-lightbox__overlay"></div>
  <div class="gcontainer avvio-lightbox__container">
    <div class="glightbox-slider-container avvio-lightbox__slider-container">
  <div id="glightbox-slider" class="gslider avvio-lightbox__slider"></div>
      <div class="avvio-lightbox__controls">
        <button class="gnext avvio-lightbox__button-next gbtn avvio-lightbox__button" tabindex="0" aria-label="Next">{nextSVG}</button>
        <button class="gprev avvio-lightbox__button-previous gbtn avvio-lightbox__button" tabindex="1" aria-label="Previous">{prevSVG}</button>
        <button class="gclose avvio-lightbox__button-close gbtn avvio-lightbox__button" tabindex="2" aria-label="Close">{closeSVG}</button>
      </div>
    </div>
  </div>
</div>`;
}

let customSlideHTML =
  `<div class="gslide avvio-lightbox__slide">
  <div class="gslide-inner-content avvio-lightbox__slide-inner-content">
    <div class="ginner-container avvio-lightbox__slide-inner-container">
            <div class="gslide-media avvio-lightbox__slide-media">
            </div>
            <div class="gslide-description avvio-lightbox__slide-description-container">
                <div class="gdesc-inner avvio-lightbox__slide-description-inner">
                    <h4 class="gslide-title avvio-lightbox__slide-title"></h4>
                    <div class="gslide-desc avvio-lightbox__slide-description"></div>
                </div>
            </div>
        </div>
    </div>
  </div>
</div>`;

function initGLightBox(selector, variation = '') {
  const gLightbox = GLightbox({
    selector: '.js-lightbox-' + selector,
    openEffect: 'fade',
    closeEffect: 'fade',
    dragToleranceY: 0,
    lightboxHTML: customLightboxHTML(variation),
    slideHTML: customSlideHTML,
    svg: {
      close: '<svg class="avvio-lightbox__button-close-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.10216 7.983L15.3197 1.78213C15.4425 1.63904 15.5067 1.45497 15.4994 1.26672C15.4921 1.07847 15.4139 0.899895 15.2803 0.766681C15.1468 0.633468 14.9677 0.555427 14.7789 0.548156C14.5902 0.540885 14.4056 0.604918 14.2622 0.727459L8.04466 6.92833L1.82716 0.719979C1.68593 0.579129 1.49438 0.5 1.29466 0.5C1.09493 0.5 0.903385 0.579129 0.762158 0.719979C0.62093 0.860829 0.541589 1.05186 0.541589 1.25105C0.541589 1.45025 0.62093 1.64128 0.762158 1.78213L6.98716 7.983L0.762158 14.1839C0.683646 14.2509 0.619881 14.3334 0.574864 14.4262C0.529846 14.519 0.504549 14.6201 0.500559 14.7231C0.496569 14.8261 0.513973 14.9289 0.551679 15.0249C0.589385 15.1208 0.646579 15.208 0.71967 15.2809C0.792761 15.3538 0.880171 15.4109 0.976415 15.4485C1.07266 15.4861 1.17566 15.5034 1.27895 15.4994C1.38224 15.4955 1.48359 15.4702 1.57664 15.4253C1.66968 15.3804 1.75242 15.3168 1.81966 15.2385L8.04466 9.03767L14.2622 15.2385C14.4056 15.3611 14.5902 15.4251 14.7789 15.4178C14.9677 15.4106 15.1468 15.3325 15.2803 15.1993C15.4139 15.0661 15.4921 14.8875 15.4994 14.6993C15.5067 14.511 15.4425 14.327 15.3197 14.1839L9.10216 7.983Z" fill="#081632"/></svg>',
      next: '<svg class="avvio-lightbox__button-next-svg" width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 11L6 6L1 1" stroke="#112856" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      prev: '<svg class="avvio-lightbox__button-previous-svg" width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 1L1 6L6 11" stroke="#112856" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    },
    zoomable: false,
    closeOnOutsideClick: false,
  });

  CloseOnOverlayClick(gLightbox);
}

function getGalleryClass() {
  let galleryClass = document.querySelectorAll('.js-lightbox');

  for (let i = 0; i < galleryClass.length; i++) {
    if ("variation" in galleryClass[i].dataset) {
      initGLightBox(galleryClass[i].id, galleryClass[i].dataset.variation);
    } else {
      initGLightBox(galleryClass[i].id);
    }
  }
}

getGalleryClass();

function CloseOnOverlayClick(lightbox) {
  if (lightbox) {
    document.addEventListener('click', function (event) {
      if (event.target.classList.contains('glightbox-slider-container')) {
        lightbox.close();
      }
    });
  }
}
class GLightboxDynamicCaption {
  constructor(options) {
    this.options = Object.assign(
      {
        wrapper: ".js-avvio-gallery__wrapper",
        captionElement: ".js-avvio-gallery__caption",
        instance: typeof gLightbox != "undefined" && gLightbox,
      },
      options
    );

    this.captionObject = [];
  }

  getCaptionObject() {
    this.captionObject = [];

    if (!this.options.instance) return false;

    let { elements } = this.options.instance;

    if (!elements) return false;

    elements.forEach((element) => {
      let wrapper = element.node.closest(this.options.wrapper);
      if (!wrapper) {
        this.captionObject.push(element);
        return false;
      }

      let caption = wrapper.querySelector(this.options.captionElement);
      if (!caption) {
        this.captionObject.push(element);
        return false;
      }

      let captionHTML = caption.innerHTML;

      this.captionObject.push(Object.assign(element, { description: captionHTML }));
    });

    return this.captionObject;
  }

  updateLightbox() {
    const newCaptionObject = this.getCaptionObject();

    if (!newCaptionObject) return false;

    this.options.instance.setElements(this.captionObject);
  }

  previewInit() {
    const that = this;
    document.addEventListener("DOMContentLoaded", () => {
      that.updateLightbox();
    });
  }
}

const gLightboxDynamicCaption = new GLightboxDynamicCaption();

/**
 * Initialize the script when the block is previewed within the editor
 * https://www.advancedcustomfields.com/resources/javascript-api/
 */
// document.addEventListener("DOMContentLoaded", gLightboxDynamicCaption.updateLightbox()); 
gLightboxDynamicCaption.previewInit();